import type { CommentElementProps } from './comment-element.component';
import CommentElement from './comment-element.component';

export interface CommentsListProps {
  comments?: Array<CommentElementProps>;
  readOnly?: boolean;
}

export default function CommentsList({ comments, readOnly }: CommentsListProps): JSX.Element {
  return (
    <>
      {comments?.map((comment, index) => {
        return (
          <div key={comment.id || comment.date || `comment-${index}`} className="custom-scroll odin-overflow-x-auto">
            <CommentElement user={comment.user} date={comment.date} message={comment.message} readOnly={readOnly} />
          </div>
        );
      })}
    </>
  );
}
